VLW.ContentGroup = function (doinit) {
	if (doinit) this.init();
}

VLW.ContentGroup.prototype = {
	initBind            : function () {
		for (var i in this) {
			if (typeof (this[i]) === "function") {
				this[i] = this[i].bind(this);
			}
		}
	},
	init                : function () {
		this.initBind();
		this.controllers = [];
		this.count       = 0;
		this.events      = {
			ongroupoutrodone: new signals.Signal()
		};
	},
	setParentController : function (controller) {
		if (controller === this.parentController) return;
		if (this.parentController) this.unregisterParent(this.parentController);
		this.registerParent(controller);
	},
	registerParent      : function (controller) {
		controller.events.beforedeactivate.add(this.beforeParentDeactivate);
		controller.events.ondeactivate.add(this.onParentDeactivate);
		controller.events.onremove.add(this.onParentRemove);
	},
	unregisterParent    : function (controller) {
		controller.events.beforedeactivate.remove(this.beforeParentDeactivate);
		controller.events.ondeactivate.remove(this.onParentDeactivate);
		controller.events.onremove.remove(this.onParentRemove);
	},
	registerController  : function (controller) {
		this.controllers.push(controller);
		this.count = this.controllers.length;
		this.bindController(controller);
		controller.contentGroup = this;
		//controller.onRegisterInGroup(controller);
		this.controllers.forEach((e)=>e.onRegisterNewInGroup(e));

	},
	unregisterController: function (controller) {
		this.unbindController(controller);
		let l = this.controllers.length;
		for (; --l > -1;) {
			if (this.controllers[l] === controller) {
				this.controllers[l] = null;
				this.controllers.splice(l, 1);
			}
		}
		this.count = this.controllers.length;
	},
	bindController      : function (controller) {
		controller.events.beforeactivate.add(this.beforeControllerActivate);
		controller.events.beforedeactivate.add(this.beforeControllerDeactivate);
		controller.events.ondeactivate.add(this.onControllerDeactivate);
	},
	unbindController    : function (controller) {
		controller.events.beforeactivate.remove(this.beforeControllerActivate);
		controller.events.beforedeactivate.remove(this.beforeControllerDeactivate);
		controller.events.ondeactivate.remove(this.onControllerDeactivate);
	},

	beforeParentDeactivate: function () {
		this.count   = this.controllers.length;
		let l        = this.count,
			children = this.count;
		if (!l) {
			this.events.ongroupoutrodone.dispatch(this);
		}
		for (; --l > -1;) {
			let ctrl = this.controllers[l];
			if (ctrl.activated) {
				ctrl.introBlockedByParent = true;
				ctrl.events.onremove		.add(this.onNewFunction3);
				ctrl.events.dooutroparent	.add(this.onNewFunction3);
				ctrl.deactivate();
			} else {
				children--;
				ctrl.events.ondeactivate.dispatch(ctrl);

				//$ctrl.trigger('ondeactivate');
				ctrl.rendered && ctrl.remove();
				if (children == 0) {
					this.events.ongroupoutrodone.dispatch(this);
					//$(this).trigger('ongroupoutrodone');
					//self = null;
				}
			}
		}
	},
	onNewFunction3        : function (controller) {
		controller.events.onremove.remove(this.onNewFunction3);
		controller.events.dooutroparent.remove(this.onNewFunction3);
		let children = this.controllers.length;
		if (children == 0) {
			this.events.ongroupoutrodone.dispatch(this);
		}
	},

	onParentDeactivate             : function () {
	},
	onParentRemove                 : function () {
		let l = this.count;
		for (; --l > -1;) {
			this.controllers[l].events.ondeactivate.dispatch(this.controllers[l]);
			this.controllers[l].rendered && this.controllers[l].remove();
		}
	},
	beforeControllerActivate       : function (controller) {
		this.count = this.controllers.length;
		if (this.count > 1) {
			controller.introDelayedByGroup = true;
			for (let l = this.count - 1; l >= 0; l--) {
				let ctrl = this.controllers[l];
				if (ctrl !== controller) {
					ctrl.events.onintroready	.remove(this.onControllerIntroReady);
					ctrl.events.onremove		.add(this.onNewFunction);
					ctrl.events.dolaunchnext	.add(this.onNewFunction);
					ctrl.controllerToTrig = controller;
					ctrl.deactivate();
				}
			}
		} else {
			controller.events.onintroready.add(this.onControllerIntroReady);
		}
	},
	onNewFunction                  : function (controller) {
		//console.log("%c		onNewFunction","background-color:#B36D35",controller.uid,controller.constructor.name,controller.controllerToTrig.uid);
		if (controller) {
			controller.events.onremove		.remove(this.onNewFunction);
			controller.events.dolaunchnext	.remove(this.onNewFunction);
			if (controller.controllerToTrig ) {
				this.onControllerIntroResumedByGroup(controller.controllerToTrig);
			}
		}
	},
	onControllerIntroReady         : function (controller) {
		document.body.style.cursor='auto';
		controller.events.onintroready.remove(this.onControllerIntroReady);
		(!controller.introDelayedByGroup && controller.intro());
	},
	onControllerIntroResumedByGroup: function (controller) {
		document.body.style.cursor='auto';
		controller.introDelayedByGroup = null;
		(controller.readyForIntro && controller.intro());
	},
	beforeControllerDeactivate     : function (e) {
		e.events.onoutroready.add(this.onNewFunction2);
	},
	onNewFunction2                 : function (controller) {
		controller.events.onoutroready.remove(this.onNewFunction2);
		controller.outro();
	},
	onControllerDeactivate: function (controller) {
		controller.events.onintroready.remove(this.onControllerIntroReady);
		this.unregisterController(controller);
	},
	getActiveIds          : function () {
		this.count = this.controllers.length;
		let ids    = [], l = this.count;
		for (; --l > -1;) {
			ids.push(this.controllers[l].id);
		}
		return ids;
	}
};